import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component
class ToggleMixin extends Vue {
    @Prop()
    disabled;
    @Prop({ type: String })
    focus;

    @Model('input')
    model;

    get state() {
        return this.model;
    }

    set state(value) {
        this.$emit('input', value);
        if (value && this.focus) {
            $('#' + this.focus).focus();
        }
    }
}

export default ToggleMixin;
